import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Container } from '../styles/styled';
import BG from '../images/bg-image2.png';

const CoverageWrapper = styled.section`
    padding: 60px 0;
    background-image: url(${BG});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;   
    >div{
        text-align: center;
        color: #fff;
        >h2{
            font-size: 26px;
        }
        >p{
            font-size: 16px;
            line-height: 1.6;
            max-width: 800px;
            margin: 0 auto;
        }
    }
`;

const Coverage = () => {
    const { t } = useTranslation('common');
    return (
        <CoverageWrapper>
            <Container>
                <h2>{t('coverage.title')}</h2>
                <br/>
                <p>{t('coverage.description1')}</p>
                <br/>
                <p>{t('coverage.description2')}</p>
            </Container>
        </CoverageWrapper>
    );
}

export default Coverage;